import React from 'react';
import ParagraphNewsAll from './All';
import ParagraphNewsSelection from './Selection';

const ParagraphNews = ({ entity }) => {
  const includeAllResults = entity.getIn(['field_include_all_results', 0, 'value'], false);
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  if (includeAllResults) {
    return <ParagraphNewsAll paragraphKey={paragraphKey} entity={entity} />;
  }

  return (
    <ParagraphNewsSelection paragraphKey={paragraphKey} entity={entity} />
  );
};

export default ParagraphNews;
